import { combineLatest, type MonoTypeOperatorFunction, type Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

export function waitUntil<T>(observableToWait: Observable<any>): MonoTypeOperatorFunction<T> {
    return (source: Observable<T>) => combineLatest([source, observableToWait.pipe(take(1))]).pipe(map(([src]) => src));
}
